

const DisneyoriginalApi = [
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/3639/1433639-v-4667d2acb4c6",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/6462/1436462-v-e688776a6e16",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/5162/875162-v",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/9157/1429157-v-c0a5806446c1",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_1_5x/sources/r1/cms/prod/2974/1412974-v-6b0c211e8292",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
    {
        img:"https://img1.hotstarext.com/image/upload/f_auto,t_web_vl_3x/sources/r1/cms/prod/8475/1408475-v-6e786e852f71",
        des:"It is a nice movie to watch , hope you will never regret after watching this one 😊",
        time:"1h:24m",
        name:"Shang-chi",
    },
   
]

export default DisneyoriginalApi;